export enum RenewalType {
  AUTO = 'AUTO',
  NEVER = 'NEVER',
  MANUAL = 'MANUAL',
}
